import { Injector, Pipe, PipeTransform } from "@angular/core";
import { Rule } from '../data/rules';
import { RuleHelper } from '../utilities/rule.helper';
import { isDefined } from "@softline/core";

@Pipe({
  name: 'booleanRule',
  standalone: true,
  pure: true,
})
export class BooleanRulePipe implements PipeTransform {
  constructor(private injector: Injector) {
  }

  transform(
    rule: undefined | boolean | Rule,
    value: any,
    defaultValue: boolean = false
  ): boolean {
    if (!isDefined(rule))
      return defaultValue;
    return RuleHelper.getBoolean(rule, value, this.injector);
  }
}
